import { ApiResource } from '../api-resource';
import { Course } from '../course/course.model';
import { MessageChannel } from '../message-channel/message-channel.model';
import { Endpoint } from '../api.decorators';
import {
  BlobField,
  Field,
  StringField,
} from '../../util/components/resource/resource-fields';
import { CourseTemplate } from '../course-template/course-template.model';
import {
  CourseThemeSync,
  createSyncCourseThemeFormGroup,
  Sync,
} from '../_lib/sync';

@Endpoint('course-themes', 'CourseTheme')
export class CourseTheme extends ApiResource<CourseTheme> {
  @StringField({ label: $localize`Name` })
  name!: string;

  @StringField({ label: $localize`Intro` })
  intro!: string | null;

  @StringField({ label: $localize`Description` })
  description!: string | null;

  @StringField({ label: $localize`Intro for organizations` })
  introForOrganization?: string | null;

  @StringField({ label: $localize`Description for organizations` })
  descriptionForOrganization?: string | null;

  @StringField({ label: $localize`Manuscript URL` })
  manuscriptUrl!: string;

  @Field({ type: () => Course, readonly: true })
  courses?: Course[];

  @Field({ type: () => CourseTemplate, readonly: true, includeFilter: false })
  courseTemplates?: CourseTemplate[];

  @BlobField({ label: $localize`Thumbnail` })
  thumbnail!: string | null;

  @Field()
  channel!: MessageChannel;

  @Field({
    includeFilter: false,
    formControlFactory: (fb) => createSyncCourseThemeFormGroup(fb),
  })
  sync?: Sync<'uitTheme', CourseThemeSync>;

  override toLabel(): string {
    return this.name;
  }

  // Virtual columns
  totalRegistrations!: number;
  hasActiveCourses!: boolean;
}
